// removed by extract-text-webpack-plugin
module.exports = {"loader":"Spinner__loader__-hash-base-64-5-","load6":"Spinner__load6__-hash-base-64-5-","round":"Spinner__round__-hash-base-64-5-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/Spinner/Spinner.css
// module id = 174
// module chunks = 0